// /opt/isp_erp/frontend/src/api/ftth_geo.api.js
import api from './api';

export const ftthGeoAPI = {
  // ---- Importación ----
  subirKmz: async (file, onProgress) => {
    const form = new FormData();
    form.append('archivo', file);
    const { data } = await api.post('/ftth/geo/import/kmz', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: onProgress,
    });
    return data;
  },

  reprocesarImport: async (jobId) => {
    const { data } = await api.post(`/ftth/geo/import/jobs/${jobId}/reprocesar`);
    return data;
  },

  eliminarImport: async (jobId, borrarElementos = true, borrarArchivo = true) => {
    const { data } = await api.delete(`/ftth/geo/import/jobs/${jobId}`, {
      params: {
        borrar_elementos: borrarElementos,
        borrar_archivo: borrarArchivo,
      },
    });
    return data;
  },

  subirCsv: async (file, onProgress) => {
    const form = new FormData();
    form.append('archivo', file);
    const { data } = await api.post('/ftth/geo/import/csv', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: onProgress,
    });
    return data;
  },

  getJobs: async () => (await api.get('/ftth/geo/import/jobs')).data,

  // ---- Elementos / Cables ----
  getTopologia: async () => (await api.get('/ftth/geo/topologia')).data,
  getElementos: async (params) => (await api.get('/ftth/geo/elementos', { params })).data,
  getCables: async () => (await api.get('/ftth/geo/cables')).data,
  crearElemento: async (data) => (await api.post('/ftth/geo/elementos', data)).data,
  crearCable: async (data) => (await api.post('/ftth/geo/cables', data)).data,

  // ---- 🆕 Elementos: obtener, actualizar, eliminar, imagen ----
  getElemento: async (id) => {
    const { data } = await api.get(`/ftth/geo/elementos/${id}`);
    return data;
  },

  actualizarElemento: async (id, payload) => {
    const { data } = await api.put(`/ftth/geo/elementos/${id}`, payload);
    return data;
  },

  eliminarElemento: async (id) => {
    const { data } = await api.delete(`/ftth/geo/elementos/${id}`);
    return data;
  },

  subirImagenElemento: async (id, file) => {
    const form = new FormData();
    form.append('archivo', file);
    const { data } = await api.post(
      `/ftth/geo/elementos/${id}/imagen`,
      form,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return data;
  },
  // ---- 🆕 Cables: reconectar ----
  reconectarCable: async (cableId, payload) => {
    const { data } = await api.put(`/ftth/geo/cables/${cableId}/reconectar`, payload);
    return data;
  },
};
